/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { ReduxState } from '@/types/redux'
import { updateSaasUserProfileRequest } from '@/reducers/asyncRequests/registry'

import { updateSaasUserProfile, resetSaasUserProfileRequest } from '../../../actions/saasUsers'

import UserEmailForm from './UserEmailForm'

import type { DispatchProps, StateProps, ConsumerProps } from './types'

const mapStateToProps = (state: ReduxState, { userId }: ConsumerProps): StateProps => ({
  updateSaasUserProfileRequest: updateSaasUserProfileRequest(state, String(userId)),
})

const mapDispatchToProps = (dispatch, { userId }: ConsumerProps): DispatchProps => ({
  updateSaasUserProfile: (email) => dispatch(updateSaasUserProfile(userId, { email })),
  resetSaasUserProfileRequest: () => dispatch(resetSaasUserProfileRequest(String(userId))),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(UserEmailForm)
